export const trimWhitespaces = str => {
  return str.split(/\s/).join('');
};